// Folds the spellings a typist does not choose between into one, so a search
// finds "أربيل" from "اربيل" and "erbil" from "Erbil". Hamza and madda seats
// collapse onto their bare letter, harakat and tatweel drop, and the Kurdish
// letters fold onto their Arabic twins — the geo names mix both.
const FOLDS: [RegExp, string][] = [
  [/[ً-ٰٟـ]/g, ''],
  [/[̀-ͯ]/g, ''],
  [/[أإآٱ]/g, 'ا'],
  [/ة/g, 'ه'],
  [/ە/g, 'ه'],
  [/[ىیئ]/g, 'ي'],
  [/ؤ/g, 'و'],
  [/ک/g, 'ك'],
];

export const foldSearch = (text?: string | null) =>
  FOLDS.reduce(
    (folded, [pattern, to]) => folded.replace(pattern, to),
    (text || '').normalize('NFKC').toLowerCase(),
  )
    .replace(/\s+/g, ' ')
    .trim();

// True when the query is found in any of the given names. An empty query
// matches everything, so an untouched field still offers the whole list.
export const matchesSearch = (
  query: string,
  names: (string | null | undefined)[],
) => {
  const needle = foldSearch(query);
  if (!needle) return true;
  return names.some((name) => foldSearch(name).includes(needle));
};
